export function SellerBenefits() {
  const benefits = [
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'No Commission Fees',
      description: 'When you sell directly to us, you avoid paying real estate agent commissions that typically range from 5-6% of the sale price. On a $500,000 duplex, that\'s $25,000-$30,000 saved in your pocket.'
    },
    {
      icon: 'ri-tools-line',
      title: 'No Repairs Required',
      description: 'We buy your property as-is, meaning you don\'t need to spend thousands on repairs, renovations, or updates. No painting, no fixing leaky roofs, no replacing old appliances or HVAC systems.'
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'Close on Your Timeline',
      description: 'Need to close quickly? We can close in 7-14 days. Need more time to relocate? We can accommodate your schedule. You control the closing date that works best for your situation.'
    },
    {
      icon: 'ri-file-text-line',
      title: 'Simple Paperwork',
      description: 'We handle all the complex documentation, legal requirements, and administrative tasks. Our experienced team manages the entire process from offer to closing, making it stress-free for you.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Guaranteed Closing',
      description: 'All-cash offers mean no financing contingencies or appraisal issues. Once we make an offer and you accept, you can count on us to close. No last-minute surprises or deals falling through.'
    },
    {
      icon: 'ri-user-heart-line',
      title: 'Tenant Management',
      description: 'We handle all tenant communications, lease assignments, and security deposit transfers. You don\'t need to worry about notifying tenants or coordinating with them during the sale process.'
    }
  ];

  return (
    <section className="py-20 bg-amber-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Benefits of Selling Your Small Apartment Building to Us
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Experience a faster, easier, and more profitable way to sell your duplex, triplex, quadplex, or small apartment building.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {benefits.map((benefit, index) => (
            <div key={index} className="bg-white p-8 rounded-xl shadow-lg">
              <div className="w-14 h-14 bg-orange-500 rounded-lg flex items-center justify-center mb-6">
                <i className={`${benefit.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">{benefit.title}</h3>
              <p className="text-gray-600 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          <div className="grid lg:grid-cols-2">
            <div className="p-8 lg:p-12">
              <h3 className="text-3xl font-bold text-gray-900 mb-6">
                Compare: Traditional Sale vs. Selling to Us
              </h3>
              
              <div className="space-y-6">
                <div>
                  <h4 className="text-xl font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-close-circle-line text-red-500 text-2xl mr-3"></i>
                    Traditional Sale
                  </h4>
                  <ul className="space-y-2 ml-11">
                    <li className="text-gray-600">• 6-12 months average time to sell</li>
                    <li className="text-gray-600">• 5-6% commission fees ($25,000-$30,000+)</li>
                    <li className="text-gray-600">• Repairs and renovations required</li>
                    <li className="text-gray-600">• Multiple showings and open houses</li>
                    <li className="text-gray-600">• Financing contingencies and delays</li>
                    <li className="text-gray-600">• Deals often fall through</li>
                    <li className="text-gray-600">• Ongoing carrying costs during sale</li>
                  </ul>
                </div>

                <div>
                  <h4 className="text-xl font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-checkbox-circle-line text-green-500 text-2xl mr-3"></i>
                    Selling to Us
                  </h4>
                  <ul className="space-y-2 ml-11">
                    <li className="text-gray-600">• Close in 7-14 days</li>
                    <li className="text-gray-600">• Zero commission fees</li>
                    <li className="text-gray-600">• Sell as-is, no repairs needed</li>
                    <li className="text-gray-600">• No showings or staging required</li>
                    <li className="text-gray-600">• All-cash offer, no contingencies</li>
                    <li className="text-gray-600">• Guaranteed closing</li>
                    <li className="text-gray-600">• Minimal carrying costs</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="relative min-h-[400px]">
              <img 
                src="https://public.readdy.ai/ai/img_res/75626ca39f13acc3f69d3e71ecebcce8.jpg"
                alt="Successful Property Sale"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}